import { Box, Text } from "@chakra-ui/react";
import React, { useMemo } from "react";

import ReportDataTable from "../../reports/ReportDataTable";
import AgentServicesTable, {
  renderAgentTicketsPerServiceCell,
} from "../tables/AgentServicesTable";
import {
  AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  usesUnifiedTable,
} from "../../../store/renderConfig";
import { getAgentTicketsPerServiceRowsByBranch } from "../../../store/agentTicketsPerServiceExport";
import EnterpriseReportSummary from "../../reports/EnterpriseReportSummary";
import { buildTicketVolumeInsights } from "../../../store/reportEnterpriseInsights";

const SERVICE_COLUMN = Object.freeze({ id: "serviceName", label: "Service", pinned: true });

const UnifiedBranchTable = ({ branchName, servicesData, renderConfig, onRenderConfigChange }) => {
  const rows = useMemo(
    () => getAgentTicketsPerServiceRowsByBranch({ branchName, servicesData }, renderConfig),
    [branchName, renderConfig, servicesData]
  );

  return (
    <Box className="agentTicketsPerServiceUnifiedBlock" mt="16px" mb="24px">
      <ReportDataTable
        pinnedColumns={[SERVICE_COLUMN]}
        columns={AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS}
        rows={rows}
        renderConfig={renderConfig}
        renderCell={renderAgentTicketsPerServiceCell}
        presortedRows={true}
        onSortChange={(sort) => onRenderConfigChange?.({ ...renderConfig, sort })}
      />
    </Box>
  );
};

const AgentServices = ({ data, renderConfig, onRenderConfigChange }) => {
  return (
    <Box>
      {data.map(
        ({ branchName, servicesData, numServices }, branchIndex) => {
          const title = `${branchIndex + 1}. ${branchName}`;
          const insights = buildTicketVolumeInsights({ branchName, servicesData }, { scopeLabel: "Agent" });
          const useUnifiedTable = usesUnifiedTable(renderConfig, {
            columnDefinitions: AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
          });

          return (
            <React.Fragment key={branchIndex}>
              <h2>{title}</h2>
              <Text>{numServices} services.</Text>
              <EnterpriseReportSummary
                title="Agent Ticket Mix Summary"
                kpis={insights.kpis}
                tables={insights.tables}
                notes={insights.notes}
              />
              {useUnifiedTable ? (
                <UnifiedBranchTable
                  branchName={branchName}
                  servicesData={servicesData}
                  renderConfig={renderConfig}
                  onRenderConfigChange={onRenderConfigChange}
                />
              ) : (
                servicesData.map((data, index) => {
                  return (
                    <AgentServicesTable
                      key={index}
                      index={index}
                      serviceData={data}
                      branchIndex={branchIndex}
                      branchName={branchName}
                      renderConfig={renderConfig}
                      onRenderConfigChange={onRenderConfigChange}
                    />
                  );
                })
              )}
            </React.Fragment>
          );
        }
      )}
    </Box>
  );
};

export default AgentServices;
